/* eslint-disable import/no-cycle */
// import { combineReducers } from "redux";
import { combineReducers } from '@reduxjs/toolkit';
import scenarioSlice from 'src/pages/analytics/simulator/scenarios/store/scenario-slice';
import simulatorHomeSlice from 'src/pages/analytics/simulator/home/store/simulator-home-slice';
import plannerSlice from 'src/pages/analytics/simulator/planner/store/planner-slice';
import plannerSliceV2 from 'src/pages/analytics/simulator/planner_v2/store/planner-slice';
import powerBiSlice from 'src/pages/analytics/power-bi-embed-container/store/power-bi-slice';
import DrawerManagerSlice from 'src/pages/analytics/simulator/planner_v2/components/drawer/drawer-slice';
import innovationSlice from 'src/pages/analytics/simulator/innovation/store/innovation-slice';
import scenarioManagerSlice from 'src/pages/analytics/simulator/scenario-manager/scenario-manager-slice';
import scenarioManagerTopBarSlice from 'src/pages/analytics/simulator/scenario-manager/store/scenario-manager-top-bar-slice';
import summarySlice from 'src/pages/analytics/simulator/simulation-summary/store/summary-slice';
import asIsToBeSlice from 'src/pages/analytics/simulator/simulation-summary/store/as-is-to-be-slice';
import asIsToBeSliceV2 from 'src/pages/analytics/simulator/simulation-summary/store/as-is-to-be-slice-v2';
import filterSlice from 'src/pages/analytics/simulator/common/features/filters/store/filter-slice';
import notificationSlice from 'src/pages/core/websocket/store/notifications-slice';
import tableSlice from 'src/pages/analytics/simulator/common/features/table/store/table-slice';
import tableSlice2 from 'src/pages/analytics/simulator/common/features/table/store/table-slice2';
import appDrawerSlice from 'src/components/layout/appDrawer/app-drawer-slice';
import auth from './auth';
import snackbar from './snackbar';
import landingSlice from '../../pages/analytics/landing/store/landing-slice';
import homepageSlice from 'src/pages/analytics/landing/store/homepage-slice';
import pricingSimulatorSlice from '../../pages/analytics/simulator/pricing-simulator/store/pricing-simulator-slice';
import skuDelistSlice from '../../pages/analytics/simulator/sku-delist/store/sku-delist-slice';
import simulationSummarySlice from '../../pages/analytics/simulator/simulation-summary/store/simulation-summary-slice';
import userSlice from '../../components/user/user/store/user-slice';
import renovationSlice from '../../pages/analytics/simulator/renovation/store/renovation-slice';
import { LOGOUT_SUCCESS } from '../actions/types';
import scenarioComparisonSlice from '../../pages/analytics/simulator/scenario-comparison/store/scenario-comparison-slice';
import clusterSummarySlice from '../../pages/analytics/simulator/cluster-summary/store/cluster-summary-slice';
import noteDialogSlice from '../../pages/analytics/simulator/common/features/table/store/note-slice';
//import clusterSummaryTopBarSlice from '../../pages/analytics/simulator/cluster-summary/store/top-bar-slice';

const reducers = combineReducers({
  auth,
  snackbar,
  user: userSlice.reducer,
  homepage: homepageSlice.reducer,
  landing: landingSlice.reducer,
  filters: filterSlice.reducer,
  pricingSimulator: pricingSimulatorSlice.reducer,
  notifications: notificationSlice.reducer,
  drawerManager: DrawerManagerSlice.reducer,
  simulationSummary: simulationSummarySlice.reducer,
  innovation: innovationSlice.reducer,
  scenarioManager: scenarioManagerSlice.reducer,
  scenarioManagerTopBar: scenarioManagerTopBarSlice.reducer,
  skuDelist: skuDelistSlice.reducer,
  scenarios: scenarioSlice.reducer,
  renovation: renovationSlice.reducer,
  simulatorHome: simulatorHomeSlice.reducer,
  planner: plannerSlice.reducer,
  plannerV2: plannerSliceV2.reducer,
  powerBI: powerBiSlice.reducer,
  scenarioComparison: scenarioComparisonSlice.reducer,
  summary: summarySlice.reducer,
  asIsToBe: asIsToBeSlice.reducer,
  asIsToBeV2: asIsToBeSliceV2.reducer,
  table: tableSlice.reducer,
  table2: tableSlice2.reducer,
  appDrawer: appDrawerSlice.reducer,
  clusterSummary: clusterSummarySlice.reducer,
  noteDialog: noteDialogSlice.reducer,
  //clusterSummaryTopBar: clusterSummaryTopBarSlice.reducer 
});

const rootReducer = (state, action) => {
  // Clear all data in redux store to initial.
  if (action.type === LOGOUT_SUCCESS) {
    // const { auth } = state
    // state = { auth };
    // eslint-disable-next-line no-param-reassign
    state = undefined;
  }

  return reducers(state, action);
};
export default rootReducer;
